

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _angular = require('angular');

require('./lib/ui');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

var _squid = require('squid');

var _uiRouter = require('uiRouter');

var _logger = require('xo-beaver/dist/logger');

var _index = require('xo-models/src/shoppingcart/index');

require('xo-ui-components/src/accessibility/directive');

var _underscore = require('underscore/underscore.js');

var _underscore2 = _interopRequireDefault(_underscore);

var _cartUtil = require('./cartUtil');

var _cartUtil2 = _interopRequireDefault(_cartUtil);

var _cartUiUtil = require('./cartUiUtil');

var _cartUiUtil2 = _interopRequireDefault(_cartUiUtil);

var _shippingUtil = require('./shippingUtil');

var _shippingUtil2 = _interopRequireDefault(_shippingUtil);

var _util = require('../../js/lib/util');

var _util2 = _interopRequireDefault(_util);

var _redirectSanitizer = require('../../js/lib/redirectSanitizer');

var _factory = require('./factory');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var sCart = void 0,
    cartItems = void 0,
    soldoutItems = void 0,
    merchantId = void 0,
    merchantBusinessName = void 0,
    profileShippingError = void 0,
    noShippingParam = void 0,
    doNotCallShipping = void 0,
    additionalCharges = void 0;

var callUpdateCart = void 0,
    callDeleteCart = void 0,
    initiateUpdateQuantity = void 0,
    itemsToUpdate = void 0,
    calculateShippingCharges = void 0,
    setAdditionalParameters = void 0,
    fallback = void 0;

var memberXOButtonScript = void 0,
    guestXOButtonScript = void 0;
var cancelWindowScrollListener = function cancelWindowScrollListener() {};
var genericErrorCases = ['INTERNAL_SERVICE_ERROR', 'PAYEE_ACCOUNT_RESTRICTED', 'INVALID_HOSTED_BUTTON_ID', 'INVALID_INPUT', 'ITEM_PRICE_MISSING', 'NO_ADD_OR_DISPLAY'];

exports['default'] = _squid.$Component.extend('$xoShoppingCart', {
    tag: 'xo-shoppingcart-page',
    template: _template2['default'],

    resolve: {
        models: function models() {
            var _this = this;

            if (this.stateChanged) {
                return;
            }

            var shoppingCartModel = _index.$ShoppingCartModel.instance(_squid.$meta.correlationId);

            setAdditionalParameters = function setAdditionalParameters(shoppingCart) {
                sCart = $.extend(true, {}, shoppingCart);
                if (shoppingCart) {
                    _this.itemsInCart = $.extend(true, [], shoppingCart.items);
                    cartItems = $.extend(true, [], shoppingCart.items);
                    _this.currencyCode = shoppingCart.items && shoppingCart.items[0].currency;
                }
                var additionalChargesRes = _cartUtil2['default'].validateAndGetAdditionalCharges(sCart);
                if (additionalChargesRes && additionalChargesRes.cartValid) {
                    additionalCharges = $.extend(true, {}, additionalChargesRes.charges);
                    _this.additionalCharges = $.extend(true, {}, additionalChargesRes.charges);
                } else {
                    _logger.$logger.info('cart_invalid', additionalChargesRes);
                    _this.stateChanged = true;
                    return _uiRouter.$state.go('checkout.error.genericError');
                }
                _logger.$logger.info('additional_parameters', {
                    continue_shopping_url: _this.continueShoppingUrl,
                    additional_charges: additionalCharges
                });
                if (cartItems) {
                    var itemsDetails = cartItems.map(function (item) {
                        return {
                            sku: item.sku,
                            name: item.name
                        };
                    });
                    _logger.$logger.info('items_details', itemsDetails);
                }
                _this.cartTotalZero = _cartUtil2['default'].areAllItemsZeroPriced(_this.itemsInCart) && _this.getNetTotal() === 0;
            };

            calculateShippingCharges = function calculateShippingCharges() {
                if (doNotCallShipping || profileShippingError) {
                    _logger.$logger.info('SKIP_SHIPPING_CHARGES_CALL', { doNotCallShipping: doNotCallShipping, profileShippingError: profileShippingError });
                    return;
                }

                var items = _cartUtil2['default'].getItemsForShippingCalculation(cartItems);
                if (_underscore2['default'].isEmpty(items)) {
                    _logger.$logger.info('SKIP_SHIPPING_CHARGES_CALL: ITEM_LIST_EMPTY');
                    return;
                }

                return _shippingUtil2['default'].getShippingCharges(merchantId, items, noShippingParam).then(function (shippingResponse) {
                    if (shippingResponse.profileShippingError) {
                        profileShippingError = true;
                        if (sCart) {
                            delete sCart.shippingProfile;
                        }
                        return;
                    }
                    sCart.shippingProfile = shippingResponse;
                    setAdditionalParameters(sCart);
                });
            };

            callUpdateCart = function callUpdateCart(shoppingCart) {
                if (!_this.cartStateChanged) {
                    _angular.$timeout.cancel(_this.timer);
                    return;
                }
                _this.cartStateChanged = false;
                return shoppingCartModel.action('updateResource', {
                    data: {
                        request: shoppingCart
                    },
                    success: function success(result) {
                        _angular.$timeout.cancel(_this.timer);
                        setAdditionalParameters(result);
                    }
                }).then(function () {
                    return calculateShippingCharges();
                });
            };

            callDeleteCart = function callDeleteCart(shoppingCartId) {
                return shoppingCartModel.action('deleteShoppingcart', {
                    data: {
                        id: shoppingCartId
                    }
                });
            };

            return shoppingCartModel.action('resource', {
                data: {
                    mid: _squid.$meta.mid,
                    mfid: _squid.$meta.mfid
                },
                success: function success(result) {
                    // if merchant doesn't pass any URLs, last try get referrer information using previousPageUrl
                    // which is not always truthy, so url where we need to return back as continue shopping is undefined
                    _this.decidedShoppingUrl = _cartUtil2['default'].decideShoppingUrl(result, _this.previousPageUrl);
                    _this.continueShoppingUrl = (0, _redirectSanitizer.sanitizeRedirectUrl)(_this.decidedShoppingUrl) || _this.previousPageUrl;
                    _angular.$rootScope.continueShoppingUrl = _this.continueShoppingUrl;

                    if (result.shoppingCart && result.shoppingCart.resourceNotFound) {
                        _logger.$logger.info('cart_empty: shoppingCart resourceNotFound');
                        return _uiRouter.$state.go('checkout.emptyCart');
                    }

                    merchantId = result.merchantId;
                    merchantBusinessName = result.businessName;
                    noShippingParam = result.noShipping;
                    doNotCallShipping = result.doNotCallShipping;
                    setAdditionalParameters(result.shoppingCart);
                },
                contingencies: {
                    DEFAULT: function DEFAULT(err) {
                        _logger.$logger.error('SHOPPING_CART_GET_RESOURCE_ERROR', err.name);
                        return _uiRouter.$state.go('checkout.error.genericError');
                    }
                }
            }).then(function () {
                return calculateShippingCharges();
            });
        }
    },

    actions: {
        continueShopping: function continueShopping($event) {
            if ($event) {
                $event.preventDefault();
            }

            // TODO: add a util function to do this logic which is in multiple pages now
            if (window.opener && !window.opener.closed) {
                _logger.$logger.info('continue_shopping_target_not_self');
                try {
                    window.opener.location.href = this.continueShoppingUrl;
                } catch (err) {
                    _logger.$logger.info('window_opener_location_error', { err: err });
                } finally {
                    self.close();
                }
            } else {
                _logger.$logger.info('continue_shopping_target_self');
                _squid.$util.redirect(this.continueShoppingUrl);
            }
        },
        increment: function increment(index) {
            this.itemsInCart[index].quantity++;
            cartItems[index].quantity = this.itemsInCart[index].quantity;
            this.cartStateChanged = true;
            initiateUpdateQuantity();
        },
        decrement: function decrement(index) {
            if (this.itemsInCart[index].quantity > 0) {
                this.itemsInCart[index].quantity--;
                cartItems[index].quantity = this.itemsInCart[index].quantity;
                this.cartStateChanged = true;
                initiateUpdateQuantity();
            }
        },
        remove: function remove(index) {
            var _this2 = this;

            this.itemsInCart[index].removed = true;
            cartItems[index].removed = true;
            if (this.currentExpandedDetails === index) {
                this.currentExpandedDetails = undefined;
            }
            var cart = $.extend(true, {}, sCart);
            _cartUiUtil2['default'].setOrderSummaryColor();
            cart.items = itemsToUpdate();
            if (cart.items.length === 0) {
                _logger.$logger.info('all_items_removed');
                this.cartStateChanged = false;
                _angular.$q.all([callDeleteCart(cart.id)]).then(function () {
                    _this2.stateChanged = true;
                    _angular.$rootScope.continueShoppingUrl = _this2.continueShoppingUrl;
                    return _uiRouter.$state.go('checkout.emptyCart');
                });
            } else {
                this.cartStateChanged = true;
                (0, _angular.$timeout)(function () {
                    _angular.$q.all([callUpdateCart(cart)]).then(function () {
                        $('#shoppingCart').focus();
                        return;
                    });
                }, 500);
            }
        },
        updateItemAmount: function updateItemAmount(index) {
            var value = +$('input#itemTotalInput' + index).val();
            if (value && this.itemsInCart[index].quantity > 0) {
                this.itemsInCart[index].price = +(value / this.itemsInCart[index].quantity).toFixed(2);
                var cart = $.extend(true, {}, sCart);
                cart.items[index].price = this.itemsInCart[index].price;
                this.cartStateChanged = true;
                callUpdateCart(cart);
            }
        },
        keyUp: function keyUp(event, index) {
            event = event || window.event;
            if (event) {
                // 38 : up arrow, 40: down arrow
                if (event.keyCode === 38) {
                    this.actions.increment(index);
                } else if (event.keyCode === 40) {
                    this.actions.decrement(index);
                }
            }
        },
        checkValidity: function checkValidity(index, oldValue) {
            // allow user to enter only a positive integer
            if (!/^\d*$/.test(this.itemsInCart[index].quantity)) {
                cartItems[index].quantity = this.itemsInCart[index].quantity = oldValue;
            } else if (this.itemsInCart[index].quantity !== '') {
                this.cartStateChanged = true;
            } else {
                this.cartStateChanged = false;
            }
        },
        showMore: function showMore(index) {
            var _this3 = this;

            var delay = 0;

            if (this.currentExpandedDetails !== index) {
                if (this.currentExpandedDetails !== undefined) {
                    delay = 500;
                    this.actions.showLess(this.currentExpandedDetails);
                }
            }

            (0, _angular.$timeout)(function () {
                if (_this3.itemsInCart[index]) {
                    _this3.itemsInCart[index].showDetails = true;
                    _this3.itemsInCart[index].showExtraText = true;
                    $('#item' + index + 'properties').focus();
                } else {
                    _logger.$logger.info('Cannot showMore of item: ', { index: index, itemsCount: _this3.itemsInCart && _this3.itemsInCart.length });
                }
                angular.element('#item' + index + 'name').removeClass('ellipsisEffect');
                angular.element('#item' + index + 'number').removeClass('ellipsisEffect');
                if (angular.element('#item' + index + 'name').hasClass('nowrap')) {
                    angular.element('#item' + index + 'name').removeClass('nowrap');
                }
                if (angular.element('#item' + index + 'number').hasClass('nowrap')) {
                    angular.element('#item' + index + 'number').removeClass('nowrap');
                }
                if (angular.element('#item' + index + 'number').hasClass('hide')) {
                    angular.element('#item' + index + 'number').removeClass('hide');
                }

                _this3.currentExpandedDetails = index;
            }, delay);
        },
        showLess: function showLess(index) {
            if (this.itemsInCart[index]) {
                this.itemsInCart[index].showDetails = false;
                this.itemsInCart[index].showExtraText = false;
                $('#item' + index + 'properties > a:nth-child(4)').focus();
            } else {
                _logger.$logger.info('Cannot showMore of item: ', { index: index, itemsCount: this.itemsInCart && this.itemsInCart.length });
            }
            angular.element('#item' + index + 'name').addClass('ellipsisEffect');
            angular.element('#item' + index + 'number').addClass('ellipsisEffect');
            if (this.itemsInCart[index].itemNameLong) {
                angular.element('#item' + index + 'number').addClass('hide');
            }
            (0, _angular.$timeout)(function () {
                angular.element('#item' + index + 'name').addClass('nowrap');
                angular.element('#item' + index + 'number').addClass('nowrap');
            }, 500); // same time duration specified in max-height transition
            this.currentExpandedDetails = undefined;
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this4 = this;

            // initial values
            this.cartTotalZero = false;
            this.previousPageUrl = _util2['default'].previousPageUrl();

            angular.element('.merchantHeader').removeClass('showMerchantHeader');

            // Load XO buttons
            var localeInfo = _squid.$locale.lang + '_' + _squid.$locale.country;
            _logger.$logger.info('localeInfo', { country: _squid.$locale.country, lang: _squid.$locale.lang });
            memberXOButtonScript = _cartUiUtil2['default'].loadJsButton(_squid.$locale, 'member', localeInfo);
            guestXOButtonScript = _cartUiUtil2['default'].loadJsButton(_squid.$locale, 'guest', localeInfo);

            fallback = function fallback(product, reason) {
                throw new _squid.$FallbackError({
                    product: product,
                    reason: reason
                });
            };

            this.getCartItemsTotal = function () {
                return _cartUtil2['default'].getCartItemsTotal(_this4.itemsInCart);
            };

            this.getNetTotal = function () {
                var sum = _this4.getCartItemsTotal() || 0;
                _underscore2['default'].forEach(_this4.additionalCharges, function (detail) {
                    if (detail.name === 'discount') {
                        sum -= detail.value;
                    } else {
                        sum += detail.value;
                    }
                });
                return sum;
            };

            this.toggleArrowDirection = function () {
                _this4.expandSummary = !_this4.expandSummary;
                if (_this4.expandSummary) {
                    _this4.orderSummaryMaxHeight = $('.details-expand').prop('scrollHeight');
                }
                $('#orderSummary').attr('aria-expanded', _this4.expandSummary);
                (0, _angular.$timeout)(function () {
                    _cartUiUtil2['default'].setOrderSummaryColor();
                }, 500);
            };

            this.getEachItemMaxHeight = function (index) {
                return _cartUiUtil2['default'].getEachItemMaxHeight(_this4.itemsInCart, index);
            };

            this.getDetailsMaxHeight = function (index) {
                return _cartUiUtil2['default'].getDetailsMaxHeight(index);
            };

            this.getItemNameMaxHeight = function (index) {
                return _cartUiUtil2['default'].getItemNameMaxHeight(index);
            };

            this.tooLong = function (index, field) {
                if (field === 'name') {
                    _this4.itemsInCart[index].itemNameLong = true;
                } else if (field === 'number') {
                    _this4.itemsInCart[index].itemNumberLong = true;
                }
            };

            this.getContainerColWidth = function () {
                return _cartUiUtil2['default'].getContainerColWidth();
            };
        },
        populate: function populate() {
            var _this5 = this;

            if (this.stateChanged) {
                return;
            }
            $('#wrapper').addClass('cartBody');
            this.$on('$destroy', function () {
                $('#wrapper').removeClass('cartBody');
            });

            var memberCheckoutElement = document.getElementById('memberCheckout');
            var guestCheckoutElement = document.getElementById('guestCheckout');
            if (memberCheckoutElement) {
                memberCheckoutElement.appendChild(memberXOButtonScript);
            }
            if (guestCheckoutElement) {
                guestCheckoutElement.appendChild(guestXOButtonScript);
            }

            // TODO: Change cartUtil.getMerchantDetails to not accept buttonItemDetails parameter anymore after refactor ramp is complete
            var merchantDetails = _cartUtil2['default'].getMerchantDetails(sCart, {}, merchantBusinessName);
            _angular.$rootScope.$broadcast('merchantDetails', merchantDetails);

            cancelWindowScrollListener = _cartUiUtil2['default'].initWindowScrollActions(); // Window scroll - keep the order summary on screen for desktop
            _cartUiUtil2['default'].setOrderSummaryColor(); // For mobile only, change order summary to grey if there item list doesn't fit on page.
            this.expandSummary = this.itemsInCart && this.itemsInCart.length < 4; // For small number of items, initialize with summary expanded
            $('#orderSummary').attr('aria-expanded', this.expandSummary);

            // To detect JS checkout button load, watch for change in contents of div#guestCheckout.
            // The child element is initially a <script>. When the script loads, executes and renders the button, the child element would be a <span>.
            var watchJSButton = this.$watch(function () {
                return $('#guestCheckout').children().get(0) && $('#guestCheckout').children().get(0).nodeName;
            }, function (newValue, oldValue) {
                if (newValue !== oldValue && newValue === 'SPAN') {
                    // the javascript guest checkout button is now loaded
                    var guestXOButton = $('#guestCheckout > span > button');
                    if (guestXOButton) {
                        guestXOButton.attr('aria-describedby', 'payWithoutAccountMsg');
                    }
                    // add alt='' to <img> elements inside the buttons which have no alt text
                    var imgElements = $('.checkoutButtons img');
                    imgElements.attr('alt', function (index, value) {
                        return value ? value : '';
                    });
                    clearWatch();
                }
            });

            function clearWatch() {
                watchJSButton();
            }

            initiateUpdateQuantity = function initiateUpdateQuantity() {
                if (_this5.timer) {
                    _angular.$timeout.cancel(_this5.timer);
                }
                _this5.timer = (0, _angular.$timeout)(function () {
                    var cart = $.extend(true, {}, sCart);
                    cart.items = itemsToUpdate();
                    callUpdateCart(cart);
                }, 1000);
            };

            this.initiateUpdateQuantity = function (index) {
                cartItems[index].quantity = _this5.itemsInCart[index].quantity;
                initiateUpdateQuantity();
            };

            itemsToUpdate = function itemsToUpdate() {
                var items = [];
                _underscore2['default'].forEach(cartItems, function (item) {
                    if (!item.removed) {
                        if (item.quantity === '') {
                            item.quantity = 1;
                        }
                        items.push(item);
                    }
                });
                return items;
            };

            var handleInvalidAddressContingency = function handleInvalidAddressContingency(addressErrorData) {
                return _uiRouter.$state.go('checkout.error.invalidAddressError', {
                    code: addressErrorData.name,
                    data: addressErrorData.details && addressErrorData.details.errorFields
                });
            };

            this.prepareCheckout = function (flow) {

                var redirectUrl = void 0;
                var cart = $.extend(true, {}, sCart);
                cart.items = _cartUtil2['default'].getItemsForCheckout(cartItems);
                if (cart.items.length === 0) {
                    _logger.$logger.info('cart_empty');
                    _this5.cartStateChanged = false;
                    return _angular.$q.all([callDeleteCart(cart.id)]).then(function () {
                        _this5.stateChanged = true;
                        _angular.$rootScope.continueShoppingUrl = _this5.continueShoppingUrl;
                        return _uiRouter.$state.go('checkout.emptyCart');
                    });
                }

                // createPaymentCart handles pending update
                if (_this5.cartStateChanged) {
                    _this5.cartStateChanged = false;
                    _angular.$timeout.cancel(_this5.timer);
                }
                _cartUtil2['default'].removeHashKey(cart);

                var shoppingCartModel = _index.$ShoppingCartModel.instance(_squid.$meta.correlationId);
                return shoppingCartModel.action('createPaymentCart', {
                    data: {
                        shoppingCart: cart,
                        shippingProfile: cart.shippingProfile,
                        flowLoggingId: _squid.$meta.flowlogging_id,
                        mid: _squid.$meta.mid,
                        mfid: _squid.$meta.mfid
                    },
                    success: function success(result) {
                        _logger.$logger.info('Cart Created and item(s)_available');
                        // Updating token in rootscope to enable logs pick token
                        _angular.$rootScope.token = result.cartId;
                        // Elmo call moved post WPS token is available to have process_pxp_check event capture token
                        _factory.$ShoppingCartFactory.getShouldRedirectToHermes().then(function (_ref) {
                            var shouldRedirectToHermes = _ref.enabled;

                            // DTOPPOR-795 move guest/signup traffic to Weasley
                            if (flow === 'member' || shouldRedirectToHermes) {
                                _logger.$logger.info('checkout_type_member');
                                redirectUrl = _squid.$config.urls.hermesUrl;
                            } else {
                                _logger.$logger.info('checkout_type_guest');
                                redirectUrl = _squid.$config.urls.xoonUrl;
                            }
                            redirectUrl += result.cartId;
                            if (result.rm) {
                                redirectUrl += '&rm=' + ('' + result.rm);
                            }
                            if (result.mfid) {
                                redirectUrl += '&mfid=' + ('' + result.mfid);
                            }
                            redirectUrl += '&useraction=commit';
                            redirectUrl += '&country.x=' + ('' + _squid.$locale.country);
                            redirectUrl += '&locale.x=' + (_squid.$locale.lang + '_' + _squid.$locale.country);
                            _squid.$util.redirect(redirectUrl);
                        });
                    },
                    error: function error(err) {
                        _logger.$logger.info('error', err.name);
                        _logger.$logger.info('checkout_fpti', {
                            'from': 'shoppingCart',
                            'to': 'process_cart_creation',
                            'int_error_description': 'invetory_error',
                            'reason': 'CART_CREATION_FAILURE'
                        });
                        return fallback('wps', 'shoppingcart_checkout_fallback');
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(errorName) {
                            _logger.$logger.info('ppcart_mapper_create_cart_error', errorName);

                            if (genericErrorCases.indexOf(errorName) > -1) {
                                return _uiRouter.$state.go('checkout.error.genericError');
                            } else {
                                return fallback('wps', 'shoppingcart_checkout_fallback');
                            }
                        },
                        ADDRESS_ERROR: function ADDRESS_ERROR(name, data) {
                            var addressErrorData = {
                                name: name,
                                details: data
                            };
                            _logger.$logger.info('ppcart_mapper_create_cart_error_address_error', name);
                            _logger.$logger.info('ppcart_mapper_create_cart_error_address_error_data', data);
                            return handleInvalidAddressContingency(addressErrorData);
                        },
                        INVENTORY_SOLDOUT: function INVENTORY_SOLDOUT(name, data) {
                            soldoutItems = data.inventoryResponse.soldoutItems;
                            _angular.$rootScope.soldoutUrl = (0, _redirectSanitizer.sanitizeRedirectUrl)(data.inventoryResponse.soldoutUrl);
                            _logger.$logger.info('item(s)_sold_out');
                            var itemsSoldout = void 0,
                                count = void 0;
                            if ((typeof soldoutItems === 'undefined' ? 'undefined' : _typeof(soldoutItems)) === 'object') {
                                itemsSoldout = JSON.stringify(soldoutItems);
                                count = _this5.itemsInCart.length === soldoutItems.length ? 'all' : 'many';
                            } else {
                                itemsSoldout = soldoutItems;
                                count = 'one';
                            }
                            _this5.stateChanged = true;
                            return _uiRouter.$state.go('checkout.soldout', {
                                items: encodeURIComponent(itemsSoldout),
                                count: encodeURIComponent(count),
                                fromPage: 'shoppingCart'
                            });
                        }
                    }
                });
            };
        },
        exit: function exit() {
            angular.element('.merchantHeader').addClass('showMerchantHeader');
            clearInterval(this.timer);
            cancelWindowScrollListener();
        }
    }
});


_angular.$rootScope;

_angular.$timeout;

_angular.$q;

_squid.$Component;

_squid.$config;

_squid.$util;

_squid.$meta;

_squid.$locale;

_squid.$FallbackError;

_uiRouter.$state;

_logger.$logger;

_index.$ShoppingCartModel;

_redirectSanitizer.sanitizeRedirectUrl;

_factory.$ShoppingCartFactory;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-shoppingcart/directive.js
// module id = ./pages/xo-shoppingcart/directive.js
// module chunks = 0